"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { XMarkIcon } from "@heroicons/react/24/solid";

import { useLang } from "@/hooks/use-lang";

import { useEventBanner } from "../../hooks/use-event-banner";

export const EventBanner = () => {
  const { lang } = useLang();
  const { bannerInfo, showBanner, setShowBanner } = useEventBanner();

  const handleClickBanner = () => {
    if (bannerInfo?.link) window.open(bannerInfo.link, "_blank");
  };

  const handleClickClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setShowBanner(false);
  };

  if (!showBanner || !bannerInfo) return null;

  return (
    <div
      id="event-banner"
      className="inset-x-0 z-[99999] h-10 shrink-0 cursor-pointer bg-yellow-500 transition-all duration-300 hover:bg-yellow-400"
      onClick={handleClickBanner}
    >
      <div className="flex h-full items-center justify-center px-10">
        <span className="text-center text-sm font-bold text-[#BE4400] @lg:text-base">
          {lang === "zh" ? bannerInfo.text.zh : bannerInfo.text.en}
        </span>
        <button
          onClick={handleClickClose}
          className="absolute right-5 rounded-full p-1 hover:bg-white hover:bg-opacity-20"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
